module.exports = __webpack_public_path__ + "img/homePageimg4.bf2f4bd0.png";